import { Button, IconCompareAdd16 } from '@cian/ui-kit';
import * as React from 'react';

interface IComparisonButtonActiveProps {
  onClick(): void;
}

export const ComparisonButtonActive: React.FC<IComparisonButtonActiveProps> = ({ onClick }) => {
  return (
    <Button
      size="XS"
      theme="fill_secondary"
      data-mark="ComparisonControlActive"
      onClick={onClick}
      beforeIcon={<IconCompareAdd16 color="primary_100" />}
    />
  );
};
